module.exports = __webpack_public_path__ + "static/img/1-1Z52415032C45.90c9b78.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1-1Z52415032C45.jpg
// module id = 8Kv9
// module chunks = 0